export default "__VITE_ASSET__7eb5f19a__"